<template>
    <div class="large-container">
        <Tabs v-model="tabName" @on-click="tabChange">
            <TabPane label="出账单位" name="outPay">
                <keep-alive>
                    <outPay v-if="tabName=='outPay'" ref="outPay" @to="tabChange"></outPay>
                </keep-alive>
            </TabPane>
          
        </Tabs>
    </div>
    </template>
    <script>
    import outPay from './list/outPay' 
    import Qs from 'qs'
    export default {
        components:{outPay},
        data () {
            return {
                tabName: 'outPay'
            }
        },
        created () { 
            if(this.$route.query.tab){
                this.tabName=this.$route.query.tab
            }
        },
        methods: {
            tabChange (value) {
                let query={
                    ...this.$route.query,
                    tab:value
                }
                this.tabName=value;
                this.$router.replace(`/group?${Qs.stringify(query)}`)
                this.$nextTick(()=>{
                    if(this.$refs[this.tabName]){
                        this.$refs[this.tabName].search()
                    }
                })
            }
        }
    }
    </script>
    



// WEBPACK FOOTER //
// src/pages/haierProduct/components/group/Index.vue